import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { RHFSelect, RHFTextField } from '../../../fl-components/hook-form';
import Iconify from '../../../fl-components/Iconify';

export default function PollFeed() {
  // Add option state
  const [addOption, setAddOption] = useState(0);
  // Form control
  const { control, getValues, setValue } = useFormContext();

  return (
    <Box>
      <RHFTextField name="question" label="Your question" margin="dense" sx={{ mb: 3 }} />
      <RHFTextField name="option1" label="Option 1" margin="dense" />
      <RHFTextField name="option2" label="Option 2" margin="dense" />

      {addOption >= 1 && (
        <Controller
          name="option3"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <FormControl fullWidth margin="dense" variant="outlined">
              <InputLabel htmlFor="outlined-option-3">Option 3</InputLabel>
              <OutlinedInput
                id="outlined-option-3"
                {...field}
                error={!!error}
                helperText={error?.message}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        if (getValues('option4')) {
                          field.onChange(getValues('option4'));
                          setValue('option4', '');
                        } else {
                          field.onChange(getValues(''));
                        }
                        setAddOption(addOption - 1);
                      }}
                      edge="end"
                    >
                      <Iconify icon="charm:cross" />
                    </IconButton>
                  </InputAdornment>
                }
                label="Option 3"
              />
            </FormControl>
          )}
        />
      )}
      {addOption === 2 && (
        <Controller
          name="option4"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <FormControl fullWidth margin="dense" variant="outlined">
              <InputLabel htmlFor="outlined-option-4">Option 4</InputLabel>
              <OutlinedInput
                id="outlined-option-4"
                {...field}
                error={!!error}
                helperText={error?.message}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        field.onChange('');
                        setValue('option4', '');
                        setAddOption(addOption - 1);
                      }}
                      edge="end"
                    >
                      <Iconify icon="charm:cross" />
                    </IconButton>
                  </InputAdornment>
                }
                label="Option 4"
              />
            </FormControl>
          )}
        />
      )}

      {addOption !== 2 && (
        <Stack justifyContent="end" direction="row" mt={3}>
          <Button
            startIcon={<Iconify icon="akar-icons:plus" />}
            // variant="contained"
            onClick={() => setAddOption(addOption + 1)}
          >
            Add Option
          </Button>
        </Stack>
      )}

      <Box mt={5}>
        <Typography>Poll Length</Typography>
        <Stack direction="row" alignItems="center" spacing={2}>
          {/* Hour */}
          <RHFSelect
            name="day"
            label="Day"
            margin="dense"
            onChange={(e) => {
              const hourValue = getValues('hour') || 0;
              if (parseInt(e.target.value, 10) === 0 && parseInt(hourValue, 10) === 0) {
                setValue('hour', '1');
              }
              setValue('day', e.target.value);
            }}
          >
            {new Array(8).fill(0).map((_, index) => (
              <option key={index} value={`${index}`}>
                {index}
              </option>
            ))}
          </RHFSelect>

          {/* Minute */}
          <RHFSelect name="hour" label="Hour" margin="dense">
            {new Array(24).fill(0).map((_, index) => (
              <option key={index} value={`${index}`}>
                {index}
              </option>
            ))}
          </RHFSelect>
        </Stack>
      </Box>
    </Box>
  );
}
